<template>
    <!--
    Свойства компонента:
        placeholder...................placeholder принимает строку
        model.sync....................тоже самое, что и v-model
        disabled......................true - заблокировано, false (или не указанно) - активно
        size..........................big - большой, small - маленький (по умолчанию средний)
        mask..........................маска
        error.........................true - поле становится красным (по умолчанию false)
        type..........................тип поля ввода (как для стандартного input, по умолчанию text)
        text-position.................left, right, center
        error-text....................текст ошибки (появляется только если error == true и error-text не пустой)
        error-text-position...........(top-left, top-right, right, bottom-right, bottom-left, left)
        search-icon...................выводит иконку поиска
        padding.......................Уточняет отступы справа и слева (по умолчанию 16)
    События компонента:
        @click........................click по компоненту
        @input........................событие ввода текста
        @keydown......................событие нажатия на кнопку
        @onenter......................событие нажатия на enter
        @change.......................событие onchange
        @focus........................событие focus
 -->
    <div :class="(clear && inputModel.length ? getClearClass() : ' no_clear')">
        <div
            v-if="searchIcon"
            class="search-icon"
            @click="$emit('search')"
        >
            <img
                src="@/assets/images/search_icon.svg"
                alt="search"
            >
        </div>
        <svg
            v-if="clear && inputModel.length"
            class="clear_button"
            width="15"
            height="16"
            viewBox="0 0 15 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            @click.stop="clearClick()"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.21522 2.69664C1.8247 3.08717 1.8247 3.72033 2.21522 4.11085L6.10428 7.99991L2.21514 11.8891C1.82461 12.2796 1.82461 12.9127 2.21514 13.3033C2.60566 13.6938 3.23883 13.6938 3.62935 13.3033L7.5185 9.41413L11.4076 13.3032C11.7981 13.6938 12.4313 13.6938 12.8218 13.3032C13.2124 12.9127 13.2124 12.2796 12.8218 11.889L8.93271 7.99991L12.8217 4.11089C13.2123 3.72036 13.2123 3.0872 12.8217 2.69667C12.4312 2.30615 11.7981 2.30615 11.4075 2.69667L7.5185 6.5857L3.62944 2.69664C3.23891 2.30612 2.60575 2.30612 2.21522 2.69664Z"
                fill="#CFCFCF"
            />
        </svg>
        <input
            ref="textField"
            v-model="inputModel"
            :class="(error ? 'error' : '') + (size ? ' ' + size : '')"
            :min="$attrs.min"
            :max="$attrs.max"
            :style="{'text-align': textPosition, 'padding': '0 '+padding+'px', 'padding-left': searchIcon ? '40px' : ''}"
            :type="type"
            :disabled="disabled"
            :placeholder="placeholder"
            @click="click()"
            @input="input()"
            @change="change()"
            @focus="focus($event)"
            @blur="blur($event)"
            @keydown="keydown($event)"
        >
        <div
            v-if="error && errorText.length"
            :class="'error_message_window ' + errorTextPosition"
        >
            <span>{{ errorText }}</span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'SimpleInput',
    props: {
        placeholder: {
            type: String,
            default: ''
        },
        model: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'text'
        },
        error: {
            type: Boolean,
            default: false
        },
        mask: {
            type: String,
            default: ''
        },
        clear: {
            type: Boolean,
            default: false
        },
        errorText: {
            type: String,
            default: ''
        },
        errorTextPosition: {
            type: String,
            default: 'top-left'
        },
        size: {
            type: String,
            default: ''
        },
        textPosition: {
            type: String,
            default: 'left'
        },
        searchIcon: {
            type: Boolean,
            default: false
        },
        padding: {
            type: Number,
            default: 16
        }
    },
    emits: [
        'search',
        'clear',
        'click',
        'input',
        'change',
        'onenter',
        'keydown',
        'focus',
        'blur',
        'update:model'
    ],
    computed: {
        inputModel: {
            get: function () {
                return this.model
            },
            set: function (newValue) {
                this.$emit('update:model', newValue)
            }
        }
    },
    methods: {
        clearClick () {
            this.inputModel = ''
            this.$emit('clear')
        },
        click () {
            if (!this.disabled) this.$emit('click')
        },
        input () {
            if (!this.disabled) this.$emit('input')
        },
        change () {
            if (!this.disabled) this.$emit('change')
        },
        keydown (event) {
            if (!this.disabled) {
                if (event.keyCode === 13) this.$emit('onenter')
                else this.$emit('keydown', event)
            }
        },
        focus () {
            if (!this.disabled) this.$emit('focus')
        },
        blur () {
            if(!this.disabled) this.$emit('blur')
        },
        focusTextField () {
            this.$refs.textField.focus()
        },
        getClearClass () {
            if (this.size === 'big') return ' clear_big'
            if (this.size === 'small') return ' clear_small'
            if (this.size === 'super_small') return ' clear_super_small'
            return ' clear_normal'
        },
    }
}
</script>
<style scoped>
    div, input {
        width: 100%;
    }
    div {
        position: relative;
        display: flex;
        border-radius: 4px;
        overflow: hidden;
    }
    div .search-icon {
      width: 15px;
      height: 15px;
      font-size: 0;
      position: absolute;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
    }
    div .search-icon img {
      width: 100%;
      height: 100%;
    }
    input {
        -webkit-appearance: none;
        height: 38px;
        border: 1px solid var(--muted-background);
        box-sizing: border-box;
        padding: 0 16px;
        border-radius: 0;
        font-size: 14px;
        outline: none;
        border-radius: 4px;
    }
    input::placeholder {
        color: rgba(0,0,0,0.2);
    }
    input:hover {
        border: 1px solid rgba(0, 0, 0, 0.2);
    }
    input:focus {
        border: 1px solid var(--additional-yellow);
    }
    input:disabled {
        background: #F8F8F8;
        border: 1px solid rgba(0, 0, 0, 0.1);
    }
    input.big {
        height: 49px;
        font-size: 18px;
    }
    input.small {
        height: 34px;
        border: none;
        padding: 0;
        border-bottom: 1px solid rgba(0,0,0,0.1);
    }
    input.small:hover {
        border-color: rgba(0,0,0,0.2);
    }
    input.small:focus {
        border-color: #F8DB78;
    }
    input.small:disabled {
        background: #F8F8F8;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
    input.error {
        border-color: #F47676;
    }
    input.error::placeholder {
        color: #F47676;
    }
    .error_message_window {
        position: absolute;
        width: 180px;
        background: #FFFFFF;
        box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.1);
        border-right: 2px solid #FF8F80;
        padding: 2px 5px 5px;
        box-sizing: border-box;
        z-index: 500;
    }
    .error_message_window span {
        display: inline-block;
        font-size: 14px;
        line-height: 14px;
        color: rgba(0,0,0,0.6);
    }
    .top-left {
        bottom: 130%;
    }
    .top-left:after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border: 10px solid #FFFFFF;
        border-left-color: transparent;
        border-right-color: transparent;
        border-bottom-color: transparent;
        bottom: -20px;
        right: 30px;
    }
    .top-right {
        bottom: 130%;
        right: 0;
    }
    .top-right:after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border: 10px solid #FFFFFF;
        border-left-color: transparent;
        border-right-color: transparent;
        border-bottom-color: transparent;
        bottom: -20px;
        left: 30px;
    }
    .right {
        align-self: center;
        right: -200px;
    }
    .right:after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border: 10px solid #FFFFFF;
        border-top-color: transparent;
        border-left-color: transparent;
        border-bottom-color: transparent;
        left: -20px;
        bottom: calc(50% - 10px);
    }
    .bottom-right {
        top: 130%;
        right: 0;
    }
    .bottom-right:after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border: 10px solid #FFFFFF;
        border-top-color: transparent;
        border-right-color: transparent;
        border-left-color: transparent;
        top: -20px;
        left: 30px;
    }
    .bottom-left {
        top: 130%;
        left: 0;
    }
    .bottom-left:after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border: 10px solid #FFFFFF;
        border-top-color: transparent;
        border-right-color: transparent;
        border-left-color: transparent;
        top: -20px;
        right: 30px;
    }
    .left {
        align-self: center;
        left: -200px;
        border-right: none;
        border-left: 2px solid #FF8F80;
    }
    .left:after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border: 10px solid #FFFFFF;
        border-top-color: transparent;
        border-right-color: transparent;
        border-bottom-color: transparent;
        right: -20px;
        bottom: calc(50% - 10px);
    }
    div.clear_normal .clear_button {
        top: 11px;
        right: 10px;
    }
    div.clear_big input {
        padding-right: 30px !important;
    }
    div.clear_big .clear_button {
        top: 19px;
        right: 12px;
        transform: scale(1.4);
    }
    div.clear_small .clear_button {
        top: 8px;
        right: 0
    }
    div.clear_super_small input {
        padding-right: 18px !important;
    }
    div.clear_super_small .clear_button {
        top: 5px;
        right: 0
    }
    .search_icon, .clear_button, .checkbox, .radio-box {
        position: absolute;
        cursor: pointer;
    }
    .action_button,
    .clear_button {
        opacity: 0;
        transition: opacity 0.03s ease-out;
    }
    .action_button,
    .clear_button {
        opacity: 0;
        transition: opacity 0.03s ease-out;
    }
    .input_wrapper.show_action_list .action_button,
    .input_wrapper.show_action_list .clear_button,
    .input_wrapper:hover .action_button,
    .input_wrapper:hover .clear_button {
        opacity: 1;
    }
    @media only screen and (max-width: 1024px) {
        .clear_button {
            opacity: 1;
        }
    }
    .clear_button:hover {
        opacity: 0.8;
    }
</style>
